export default "__VITE_ASSET__e1c8ed8f__"